// Status
export const PENDING = 'PENDING'
export const SUCCEEDED = 'SUCCEEDED'
export const REJECTED = 'REJECTED'
// Auth Section
export const SIGN_UP = 'SIGN_UP'
export const SIGN_IN = 'SIGN_IN'
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD'
export const FORGOT_PASSWORD_VERIFY = 'FORGOT_PASSWORD_VERIFY'
export const VERIFY_LINK_PAGE = 'VERIFY_LINK_PAGE'
export const IS_VERIFY_PAGE = 'IS_VERIFY_PAGE'
// Validation
export const CHANGE_PASSWORD = 'changePassword'
export const EMAIL = 'email'
export const PASSWORD = 'password'
export const CURRENT_PASSWORD = 'currentPassword'
export const CONFIRM_PASSWORD = 'confirmPassword'
export const USER_NAME = 'userName'
export const USER_URL = 'userUrl'
// Map
export const ZOOM_LEVEL = 16
export const MAX_ZOOM_LEVEL = 16
export const MIN_ZOOM_LEVEL = 4
export const UNSUPPORTED_MAX_ZOOM_LEVEL = 25
export const MAP_URL = process.env.REACT_APP_MAP_TYPE === 'stadia'
  ? 'https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png'
  : 'https://api.maptiler.com/maps/basic-v2/256/{z}/{x}/{y}.png?key=' + process.env.REACT_APP_MAP_TILER_KEY
export const MAP_ATTRIBUTION = process.env.REACT_APP_MAP_TYPE === 'stadia'
  ? '&copy; <a href="https://stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>'
  : '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
// User Section
export const MY_PROFILES = 'MY_PROFILES'
export const SINGLE_PROFILE = 'SINGLE_PROFILE'
export const EDIT_PROFILE = 'EDIT_PROFILE'
export const SETTINGS = 'SETTINGS'
export const PROFILE_BLOG = 'PROFILE_BLOG'
// Notification Section
export const NotificationSections = {
  NOTIFICATIONS: 'NOTIFICATIONS',
  BLOG_PREFERENCE: 'BLOG_PREFERENCE',
  ENGAGEMENT_ITEM_LIST: 'ENGAGEMENT_ITEM_LIST'
}
// Verify text
export const PASSWORD_VERIFY_TEXT = 'A verification link has been sent to your current email address. Please click on the link to verify the email and create a new password. \n Kindly look for it in the spam section'
export const SIGN_UP_VERIFY_TEXT = 'A verification link has been sent to your current email address. Please click on the link to verify the email and complete the registration \n process. Kindly look for it in the spam section'
// Verify page
export const VERIFY_PAGE = {
  ForgotPassword: 'Forgot Password',
  SignIn: 'Sign In',
  SignUp: 'Sign Up',
  MyProfiles: 'My Profiles',
  FriendsProfile: 'Friends Profile',
  EditProfile: 'Edit profile',
  Settings: 'Account Settings',
  ProfileBlog: 'Profile Blog'
}
// Filters type
export const FILTERS_TYPE = {
  Own: 'own',
  CodeWord: 'code_word',
  Affinities: 'affinities'
}
// Settings type
export const SETTINGS_TYPE = {
  Profile: 'profile',
  Email: 'email',
  Password: 'password',
  Notif: 'frequency'
}
// Marker position
export const INITIAL_POSITION = [40.7128, -74.006]
export const LOCATION_TYPE = {
  LiveLocation: 'Live Location',
  LiveApproximate: 'Live, Approximate',
  StaticLocation: 'Static Location'
}
// Notification Type
export const NOTIFICATION_TYPE = {
  Accept: 'Accept',
  Reject: 'Reject',
  View_Profile: 'View User Profile'
}

export const MODAL_SECTION = {
  RightSection: 'RightSection',
  LeftSection: 'LeftSection'
}

export const URLS = {
  Odysee: 'https://www.odysee.com/',
  Flote: 'https://flote.app/'
}

export const IS_FRIEND_STATUSES = {
  pending: 'pending',
  accepted: 'accepted',
  denied: 'denied',
  no: 'no'
}

export const NOTIFICATIONS_TITLE = {
  Connector: 'connector',
  Proximity: 'proximity',
  NewUsers: 'new_users',
  Concerts: 'concerts_and_events',
  CommunityBlogs: 'community_blogs',
  Advertisers: 'advertisers',
  ConnectionRequests: 'Connection Requests',
  Engagements: 'engagements'
}

export const LOGOUT_ERR_MSG = [
  'Concurrent login is not allowed when using live location or live approximate',
  'This account will be unbanned on'
]

export const ERR_MSG_GEO_LOC = {
  0: 'Kindly allow Location Services if you want to use Live Location',
  1: 'Failed to obtain location. Kindly manually allow the location services in your browser and device settings if you want to use Live Location',
  2: 'Kindly allow Location Services as you are using Live Location'
}

export const ACCEPTED_IMG_LIST = 'image/jpeg, image/jpg, image/png, image/bmp, image/webp'

export const Month = [
  {
    id: '1',
    name: 'January',
    color: '#004cff'
  },
  {
    id: '2',
    name: 'February',
    color: '#67d7ff'
  },
  {
    id: '3',
    name: 'March',
    color: '#03ffd9'
  },
  {
    id: '4',
    name: 'April',
    color: '#55ff00'
  },
  {
    id: '5',
    name: 'May',
    color: '#ceec04'
  },
  {
    id: '6',
    name: 'June',
    color: '#fffb00'
  },
  {
    id: '7',
    name: 'July',
    color: '#ffbf00'
  },
  {
    id: '8',
    name: 'August',
    color: '#ff4c00'
  },
  {
    id: '9',
    name: 'September',
    color: '#df0000'
  },
  {
    id: '10',
    name: 'October',
    color: '#ff449b'
  },
  {
    id: '11',
    name: 'November',
    color: '#e75fff'
  },
  {
    id: '12',
    name: 'December',
    color: '#9d00ff'
  }
]

export const MonthName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']

export const EventIcon = (color, month) => `<svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <style>
        .indicator-event {
          font-size: 16px;
          font-weight: bolder;
        }
      </style>
      <path d="M17 1.90039C17.6075 1.90039 18.0996 2.39249 18.0996 3V3.90039H19C20.7121 3.90039 22.0996 5.28792 22.0996 7V19C22.0996 
      20.7121 20.7121 22.0996 19 22.0996H5C3.28792 22.0996 1.90039 20.7121 1.90039 19V7C1.90039 5.28792 3.28792 3.90039 5 3.90039H5.90039V3C5.90039 
      2.39249 6.39249 1.90039 7 1.90039C7.60751 1.90039 8.09961 2.39249 8.09961 3V3.90039H15.9004V3C15.9004 2.39249 16.3925 1.90039 17 1.90039ZM4.09961 
      19C4.09961 19.4971 4.50294 19.9004 5 19.9004H19C19.4971 19.9004 19.9004 19.4971 19.9004 19V12.0996H4.09961V19ZM5 6.09961C4.50294 6.09961 4.09961 6.50294 4.09961 
      7V9.90039H19.9004V7C19.9004 6.50294 19.4971 6.09961 19 6.09961H18.0996V7C18.0996 7.60751 17.6075 8.09961 17 8.09961C16.3925 8.09961 15.9004 7.60751 15.9004 7V6.09961H8.09961V7C8.09961 
      7.60751 7.60751 8.09961 7 8.09961C6.39249 8.09961 5.90039 7.60751 5.90039 7V6.09961H5Z" fill="#FF4D00" stroke="black" stroke-width="0.2" stroke-linecap="round"/>
      <text x="3.5" y="20" fill="black" width="10" height=20" stroke="white" stroke-width="0.4" class="indicator-event">${month}</text>
    </svg>`

export const VERIFICATION_TYPES = {
  Email: 'verify email',
  ForgotPassword: 'forgot password',
  NewEmail: 'verify new email',
  ResetPassword: 'reset password'
}

export const ENGAGEMENT_TIME_FORMAT = {
  JustNow: 'Just Now',
  ABitAgo: 'A Bit Ago',
  Today: 'Today',
  Yesterday: 'Yesterday',
  RealDateTime: 'RealDateTime'
}

export const ENGAGEMENT_TYPES = {
  likes: 'Likes',
  comments: 'Comments',
  reposts: 'Reposts',
  shares: 'Shares',
  subscriptions: 'Subscriptions',
  saves: 'Saves'
}
